import React, { Fragment, useState, useEffect } from "react";
import { NotaryProfile } from "../../components"
import { NotaryAssign } from "../buttons";
import { RestHelper } from '../../helper/restHelper'

function AdminDisplaySimilarOrders(props) {

    const [expanded, setExpanded] = useState({});
    const [showNotaryProfile, setShowNotaryProfile] = useState(false)
    const [profile, setProfile] = useState("")
    const [isLoaded, setIsLoaded] = useState(false)
    const [response, setResponse] = useState([])

    const api = RestHelper()

    function convertEpoch(value) {
        const date = new Date(value * 1000);
        const formattedDate = date.toLocaleDateString('en-US');
        const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        const fullDateTime = `${formattedDate} ${formattedTime}`;
        return fullDateTime
    }

    const getProfile = (data) => {
        setProfile(data)
        setShowNotaryProfile(true)
    }

    const changeView = () => {
        setShowNotaryProfile(false)
    }

    const loadResponse = (e) => {
        setResponse(e[0]['message'])
    }

    useEffect(() => {
        if (!isLoaded) {
            setIsLoaded(true)
            const reqData = { 'requestId': props.summaryData }
            const options = {}
            api
                .postCreate('/find-comparison-orders', options, reqData)
                .then(res => loadResponse(res))
                .catch(err => console.log(err))
        }
    }, [])

    const toggleExpand = (notary) => {
        setExpanded((prev) => ({
            ...prev,
            [notary]: !prev[notary],
        }));
    };

    return (
        <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden mt-4">
            <div className="px-4 sm:px-6 py-4 border-b border-neutral-200">
                <h2 className="text-lg font-semibold text-neutral-800">Previous Orders in this Area</h2>
                <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-neutral-50 border-b border-neutral-200">
                        <tr>
                            <th className="px-4 py-3 w-8"></th>
                            <th className="px-4 py-3 text-left font-semibold text-neutral-700">Notary Name</th>
                            <th className="px-4 py-3 text-center font-semibold text-neutral-700">Orders</th>
                            <th className="px-4 py-3 text-center font-semibold text-neutral-700">Average Fee ($)</th>
                            <th className="px-4 py-3"></th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-neutral-100">
                        {response?.map((data) => {
                            const sortedOrders = [...data.orders].sort(
                                (a, b) => b.appt_numerical_time - a.appt_numerical_time
                            );
                            return (
                                <React.Fragment key={data.notary}>
                                    {/* Summary Row */}
                                    <tr
                                        className="hover:bg-neutral-50 cursor-pointer transition-colors"
                                        onClick={() => toggleExpand(data.notary)}
                                    >
                                        <td className="px-4 py-3 text-center text-neutral-400">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className={`h-4 w-4 transition-transform ${expanded[data.notary] ? 'rotate-90' : ''}`}
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </td>
                                        <td className="px-4 py-3">
                                            <button
                                                className="text-blue-600 hover:text-blue-800 font-medium hover:underline"
                                                onClick={(e) => { e.stopPropagation(); getProfile(data.notary); }}
                                            >
                                                {data.notary_name}
                                            </button>
                                        </td>
                                        <td className="px-4 py-3 text-center text-neutral-700">{data.count}</td>
                                        <td className="px-4 py-3 text-center text-neutral-700">
                                            ${data.average_fee.toFixed(2)}
                                        </td>
                                        <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                                            <NotaryAssign
                                                requestId={props.summaryData}
                                                notary={data.notary}
                                                notary_name={data.notary_name}
                                                onClickResponse={() => { props.closeWindow() }}
                                            />
                                        </td>
                                    </tr>

                                    {/* Expanded Detail View */}
                                    {expanded[data.notary] && (
                                        <tr className="bg-neutral-50">
                                            <td colSpan="5" className="p-4">
                                                <div className="ml-8 border border-neutral-200 rounded-lg overflow-hidden">
                                                    <table className="w-full text-sm">
                                                        <thead className="bg-neutral-100 border-b border-neutral-200">
                                                            <tr>
                                                                <th className="px-3 py-2 text-left font-medium text-neutral-600">Date</th>
                                                                <th className="px-3 py-2 text-left font-medium text-neutral-600">Location</th>
                                                                <th className="px-3 py-2 text-right font-medium text-neutral-600">Fee ($)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="divide-y divide-neutral-100">
                                                            {(sortedOrders || []).map((order, idx) => {
                                                                const dateValue = order?.appt_numerical_time
                                                                    ? new Date(order.appt_numerical_time * 1000).toLocaleString()
                                                                    : '-';

                                                                const city = order?.appt_city || '';
                                                                const state = order?.appt_state || '';
                                                                const location =
                                                                    city || state ? [city, state].filter(Boolean).join(', ') : '-';

                                                                const rawFee = order?.appt_offer;
                                                                const fee = rawFee !== undefined && rawFee !== null && !isNaN(rawFee)
                                                                    ? `$${parseFloat(rawFee).toFixed(2)}`
                                                                    : '-';

                                                                return (
                                                                    <tr key={idx} className="hover:bg-neutral-100 transition-colors">
                                                                        <td className="px-3 py-2 text-neutral-700">{dateValue}</td>
                                                                        <td className="px-3 py-2 text-neutral-700">{location}</td>
                                                                        <td className="px-3 py-2 text-right text-blue-600 font-medium">{fee}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
                {(!response || response.length === 0) && (
                    <p className="text-neutral-500 text-center py-4">No previous orders found in this area</p>
                )}
            </div>

            {showNotaryProfile && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                        <div className="px-4 py-3 border-b border-neutral-200 flex justify-between items-center sticky top-0 bg-white">
                            <h3 className="text-lg font-semibold text-neutral-800">Notary Profile</h3>
                            <button
                                className="text-neutral-400 hover:text-neutral-600 p-1 rounded-lg hover:bg-neutral-100 transition-colors"
                                onClick={() => changeView()}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="p-4">
                            <NotaryProfile profile={profile} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdminDisplaySimilarOrders;
